import { IRCACorporateArgsFilters } from "./RCACorporateDashboardEntityInterfaces";

export enum RCACorporateArgsDateKey {
    INPUT_DATE = "input_date",
    MAX_DATE = "max_date",
}

export interface RCACorporateArgs {
    input_date?: string;
    max_date?: string;
    p_division_ids?: string;
    p_region_ids?: string;
}

/**
 * Builds the args object for RCA Corporate Dashboard queries.
 * Only Division / Region filters apply at corporate scope — meeting type is never sent.
 * Partial-selection semantics match the per-page compliance helper:
 *   length === total → omit (treat as "all")
 *   partial          → emit "{a,b,c}"
 *   empty            → emit "{}"   (backend returns no rows — matches Meeting Type semantics)
 */
export function buildRCACorporateArgs(
    filters: IRCACorporateArgsFilters,
    dateKey: RCACorporateArgsDateKey,
): RCACorporateArgs {
    const base: RCACorporateArgs = { [dateKey]: filters.date };

    return {
        ...base,
        ...(filters?.divisionIds &&
            filters.totalDivisions &&
            filters.divisionIds.length !== filters.totalDivisions && {
                p_division_ids: `{${filters.divisionIds}}`,
            }),
        ...(filters?.regionIds &&
            filters.totalRegions &&
            filters.regionIds.length !== filters.totalRegions && {
                p_region_ids: `{${filters.regionIds}}`,
            }),
    };
}
